export class ResolutionClassificationItemDTO {
  id?: number;
  code: string = '';
  name: string = '';
  category: string = '';
}
